import type { ReactElement, SVGProps } from "react";

export function SuccessIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53.3036 82.0388L88.0348 47.3076L82.2461 41.5188L53.3036 70.4613L38.8036 55.9613L33.0148 61.7501L53.3036 82.0388ZM60.5123 109C53.7365 109 47.3661 107.714 41.4011 105.143C35.4369 102.571 30.2486 99.0809 25.8361 94.6726C21.4236 90.2642 17.9307 85.0801 15.3573 79.1201C12.7832 73.1609 11.4961 66.793 11.4961 60.0163C11.4961 53.2196 12.7844 46.8292 15.3611 40.8451C17.9378 34.8617 21.4344 29.6571 25.8511 25.2313C30.2678 20.8046 35.4519 17.3263 41.4036 14.7963C47.3544 12.2655 53.7132 11.0001 60.4798 11.0001C67.2757 11.0001 73.6653 12.2642 79.6486 14.7926C85.6311 17.3209 90.8361 20.7967 95.2636 25.2201C99.6911 29.6434 103.17 34.8451 105.7 40.8251C108.231 46.8051 109.496 53.1946 109.496 59.9938C109.496 66.793 108.232 73.1609 105.704 79.0976C103.175 85.0334 99.6998 90.2117 95.2773 94.6326C90.8548 99.0534 85.6544 102.553 79.6761 105.133C73.6978 107.711 67.3098 109 60.5123 109Z"
        fill="#128351"
      />
    </svg>
  );
}
